import { phoneNumber, digitOnly } from '../../utils/mask';
import {
  getAddressOnly, getCity, getCountry, getZip, getState,
} from '../../utils/func';
import { AddressTypes } from '../../utils/enums';

export const getCompanyIdFromListByName = (companyName, companiesList) =>
  companiesList.filter((c) => c.companyName === companyName).map((c) => c.companyId).toString();

export const formDataToApi = (formData) => {
  const {
    companyId,
    nickname,
    address,
    addressAdditional,
    phoneNumber,
    phoneNumberExt,
    contactName,
    companyName,
    email,
    contactType,
    rowVersion,
    division,
    userId,
    residentialAddress,
    mobileNumber,
  } = formData;
  let contactTypeCode;
  switch (contactType) {
    case AddressTypes.SHIPPER:
      contactTypeCode = 'SHP';
      break;
    case AddressTypes.CONSIGNEE:
      contactTypeCode = 'CON';
      break;
    case 'billing':
    case AddressTypes.SHARED:
      contactTypeCode = 'SHR';
      break;
    case AddressTypes.OTHER:
      contactTypeCode = 'OTR';
      break;
    default:
      break;
  }

  const formValueToApi = {
    companyId,
    contactType: contactTypeCode,
    contactName,
    nickname: nickname.name ? nickname.name : nickname,
    emailAddress: email,
    contactCompanyName: companyName,
    address1: getAddressOnly(address),
    address2: addressAdditional,
    city: getCity(address),
    provinceCode: getState(address),
    countryCode: getCountry(address),
    postalCode: getZip(address),
    phoneNumber: digitOnly(phoneNumber),
    phoneNumberExtension: phoneNumberExt,
    rowVersion,
    division,
    userId,
    isResidential: residentialAddress,
    mobileNumber: Number(digitOnly(mobileNumber)),
  };

  return formValueToApi;
};

export const formApiToData = (data) => {
  const {
    nickname,
    contactName,
    companyName,
    emailAddress,
    phoneNumberExtension,
    address1,
    address2,
    city,
    provinceCode,
    countryCode,
    postalCode,
    rowVersion,
    contactId,
    mobileNumber,
    isResidential,
  } = data;
  const formValueToData = {
    nickname: { name: nickname, contactId },
    address: `${address1}, ${city}, ${provinceCode} ${postalCode}, ${countryCode}`,
    addressAdditional: address2,
    city,
    provinceState: provinceCode,
    postalZipCode: postalCode,
    countryCode,
    country: countryCode,
    phoneNumber: phoneNumber(data.phoneNumber),
    phoneNumberExt: phoneNumberExtension,
    contactName,
    companyName,
    email: emailAddress,
    rowVersion,
    residentialAddress: isResidential,
    mobileNumber: phoneNumber(String(mobileNumber)) === '0' ? null : phoneNumber(String(mobileNumber)),
  };

  return formValueToData;
};
